import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface TicketManagerNewProjectDraft {
  name: string;
  ticketPrefix: string;
}

export interface TicketManagerSettingsStateType {
  newProjectDraft: TicketManagerNewProjectDraft | null;
}

const initialState: TicketManagerSettingsStateType = {
  newProjectDraft: null,
};

export const TicketManagerSettingsState = createSlice({
  name: 'TicketManagerSettingsState',
  initialState,
  reducers: {
    setNewProjectDraft: (state, action: PayloadAction<TicketManagerNewProjectDraft>) => {
      state.newProjectDraft = action.payload;
    },
    clearNewProjectDraft: (state) => {
      state.newProjectDraft = null;
    },
  },
});

export const { setNewProjectDraft, clearNewProjectDraft } = TicketManagerSettingsState.actions;
